// @core/api/endpoints/activity/get_activity.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetActivityResponse,
} from '../../../types/activity';

const BASE_PATH = '/activity';

/**
 * Get activity by ID
 * Returns a single activity record by its ID.
 */
export async function GetActivity(
  id: string,
  options?: RequestOptions
): Promise<GetActivityResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/activities/:id`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.get<GetActivityResponse>(requestPath, { ...requestOptions });
}
